// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

type FetchSavedSearchesParams = {
    authToken: string,
    deployment: string,
};

type FetchSavedSearchItemsParams = {
    authToken: string,
    deployment: string,
};

type PostDeleteSavedSearchParams = {
    authToken: string,
    deployment: string,
    savedSearchId: any,
};

type PostIsSavedSearchParams = {
    authToken: string,
    deployment: string,
    ssParams: any,
};

type PostSaveSearchParams = {
    authToken: string,
    deployment: string,
    sendAlert: boolean,
    ssParams: any,
};

type PostSubscribeToSavedSearchParams = {
    authToken: string,
    deployment: string,
    savedSearchId: any,
};

type PostUnsubscribeFromSavedSearchParams = {
    authToken: string,
    deployment: string,
    savedSearchId: any,
};

export default {
    fetchSavedSearches: ({ authToken, deployment }: FetchSavedSearchesParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<ITEM-API>savedsearch/searches' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchSavedSearchItems: ({ authToken, deployment }: FetchSavedSearchItemsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<ITEM-API>savedsearch/items' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postDeleteSavedSearch: ({ authToken, deployment, savedSearchId }: PostDeleteSavedSearchParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'deletesavedsearch',
                authToken,
                deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ savedSearchId });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postIsSavedSearch: ({ authToken, deployment, ssParams }: PostIsSavedSearchParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'getsearchsaved',
                authToken,
                deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ facets: ssParams });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postSaveSearch: ({ authToken, deployment, sendAlert, ssParams }: PostSaveSearchParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'savesearch',
                authToken,
                deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ facets: ssParams, sendAlert });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postSubscribeToSavedSearch: ({ authToken, deployment, savedSearchId }: PostSubscribeToSavedSearchParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'subscribesavedsearch',
                authToken,
                deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ savedSearchId, sendAlert: true });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postUnsubscribeFromSavedSearch: ({ authToken, deployment, savedSearchId }: PostUnsubscribeFromSavedSearchParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'subscribesavedsearch',
                authToken,
                deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false,
            });
            request.send({ savedSearchId, sendAlert: false });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
